document.querySelectorAll('.favorite-btn:not(.wallet)').forEach(function(btn) {
  btn.addEventListener('click', function() {
    const icon = this.querySelector('i');
    const isFilledHeart = icon.classList.contains('ri-heart-fill') && icon.classList.contains('text-danger');

    icon.remove();
    const favoriteIcon = document.createElement('i');
    favoriteIcon.className = isFilledHeart ? 'ri-heart-line' : 'ri-heart-fill text-danger';
    this.querySelector(".btn").appendChild(favoriteIcon);

    if (isFilledHeart) {
      this.removeAttribute('data-bs-toggle');
      this.removeAttribute('data-bs-target');
      this.classList.remove('selected');
    } else {
      this.setAttribute('data-bs-toggle', 'modal');
      this.setAttribute('data-bs-target', '#remove');
      this.classList.add('selected');
    }
  });
});
